import React from 'react';
import Navigation from '../components/Navigation';
import Content from '../components/Content';

const IssuerLayout = ({user, role, modules}) => {
  /*
    JSX Markup for default layout component includes
    navbar, sidebar, and main content components
  */
  return (
    <div className="d-flex" id="wrapper">
      <div id="view-wrapper">
        <Navigation
          displayName={user.attributes['custom:display_name']}
          email={user.attributes['email']}
          role={role}
          modules={modules}/>
        <Content modules={modules} role={role}/>
      </div>
    </div>
  )
}

export default IssuerLayout;
